import { render, staticRenderFns } from "./DuocSapMatterList.vue?vue&type=template&id=7dcaa496&scoped=true"
import script from "./DuocSapMatterList.vue?vue&type=script&lang=js"
export * from "./DuocSapMatterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcaa496",
  null
  
)

export default component.exports